var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoadingFunc)?_c('el-container',[_c('navigation'),_vm._v(" "),_c('el-main',{class:_vm.isSubmenuFunc ?  '' : 'dashboard'},[_c('header-strip'),_vm._v(" "),_c('router-view')],1)],1):_vm._e(),_vm._v(" "),(_vm.dashLoader)?_c('div',{staticClass:"loading"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67331718","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/DesktopLayout.vue
// module id = null
// module chunks = 